//BRAND
export const name = 'AiStory';
export const company = 'Spacester';
export const websiteURL = 'https://aistory-b6fb5.web.app';
export const serverURL = 'https://aistory-xhtm.onrender.com';
export const logo = 'https://firebasestorage.googleapis.com/v0/b/india-bd34b.appspot.com/o/artificial-intelligence.png?alt=media&token=2dc0da1c-12d0-4dd2-b908-cb8e57fcf3f0';